<nav class="navbar navbar--central fixed-top" style="top: 0px;">
  <!-- Logo in nav bar -->
  <div class="container-fluid">
    <div class="navbar-policy">
      <div class="navbar-policy__breadcrumbs d-none d-lg-flex">
        <a>Edit Cover</a>
      </div>

      <a href="#modal-submenu" data-toggle="modal" class="navbar-policy__submenu d-lg-none">
        <svg class="icon">
          <use xlink:href="#submenu-alt"></use>
        </svg>
      </a>

      <div class="navbar-policy__nav d-lg-none">
        <div class="navbar-policy__nav-current"><strong>Edit Cover</strong></div>
      </div>

      <a href="javascript:;" routerLink="/question-flow" class="navbar-policy__close icon-hover" data-tooltip="tooltip" data-placement="bottom" data-original-title="Close">
        <svg class="icon">
          <use xlink:href="#close-medium"></use>
        </svg>
      </a>


    </div>
  </div>
</nav>
<main class="page-main">
  <div class="container layout layout--modal">

    <div class="layout__notice">
      <div class="notice notice--info" id="notice-changed" style="display:none;">
        <div class="notice__content">
          <svg class="icon">
            <use xlink:href="#policies"></use>
          </svg>
          <p>You’ve changed your product from [Cost Consious] to <strong>[Wonder Woman]</strong>. Update
        your policy to confirm your changes.</p>
      </div>
      <a href="#" class="button-control"><strong>Edit</strong></a>
    </div>
    <div class="notice notice--info" id="tpq-product-changed" style="display:none">
      <div class="notice__content">
        <svg class="icon">
          <use xlink:href="#policies"></use>
        </svg>
        <p>
          You’ve changed your product from [Cost Consious] to <strong>[Wonder Woman]</strong>. Update
          your policy to confirm your changes.
        </p>
      </div>
      <a href="#" class="button-control"><strong>Edit</strong></a>
    </div>
  </div>


  <div class="layout__row">
    <div class="layout__sidecol">
      <div class="layout__sidecolinner">
        <div class="card card--menu">
          <div class="card-body">
            <div class="menu-company">
              <div class="menu-company-thumb">
                <img src="/insurer/santam.svg" class="img-fluid">
              </div>
              <div class="menu-company-rating">
                <div class="stars-compact">
                  <div class="stars-compact__star">
                    <svg class="icon">
                      <use xlink:href="#star"></use>
                    </svg>
                  </div>
                  <div class="stars-compact__num">5</div>
                </div>
              </div>
              <div class="menu-company-name">
                <h5>Cost Conscious</h5>
              </div>
              <div class="menu-company-price price-strike price-strike--stacked">
                <p class="price-strike__amount">
                  <strong><em>R 253</em>.00</strong> /mo
                </p>
                <p>
                  <strong><em>R 2550</em>.50</strong> /mo
                </p>
              </div>
              <div class="modal-edit__company-fees">
                <p>
                  Including Taxes and Fees
                  <a class="popover-trigger popover-trigger--hover popover-trigger--sm" tabindex="0" data-toggle="popover" data-trigger="focus" data-content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam." data-original-title="" title="">
                    <svg class="icon icon--sm">
                      <use xlink:href="#help-Icon"></use>
                    </svg>
                  </a>
                </p>
              </div>
            </div>
          </div>

          <hr class="hr hr--bdr hr--xxs">

          <div class="card-body position-relative">
            <div class="menu-sections">
              <div class="menu-sections__section">
                <div class="menu-sections__title">
                  <small>Locations</small>
                </div>

                @for (location of locations; track location) {
                  <div class="menu-sections__item">
                    <a href="javascript:;" (click)="setLocation(location)" class="menu-sections__item-title" [ngClass]="location?.location_id === selectedLocation?.location_id ? 'is-active' : null">
                      <div class="menu-sections__item-text">
                        <h4>{{location?.location_name}}</h4>
                      </div>
                      <div class="menu-sections__item-caret">
                        <svg class="icon">
                          <use xlink:href="#chevron-right-small"></use>
                        </svg>
                      </div>
                    </a>
                  </div>
                }


              </div>
              @for (group of grouping; track group) {
                <div class="menu-sections__section" id="menu-section-{{group?.group_ig}}">
                  <div class="menu-sections__title">
                    <small>Cover {{group?.group_name}}</small>
                  </div>
                  @for (class of getGroupingClasses(group); track class) {
                    <div class="menu-sections__item has-accordion">
                      <a href="#menu-section-{{group?.group_id}}-{{class?.class_id}}" class="menu-sections__item-title collapsed" [ngClass]="class?.class_id === selectedClass?.class_id ? 'is-active': null"  data-toggle="collapse" aria-expanded="false">
                        <div class="menu-sections__item-text" >
                          <img src="assets/icn/class/sm-benefit.svg" class="icon icon--lg">
                          <h4>{{class?.answer}}</h4>
                        </div>
                        <div class="menu-sections__item-caret">
                          <svg class="icon">
                            <use xlink:href="#chevron-down"></use>
                          </svg>
                        </div>
                      </a>
                      <div class="menu-sections__item-content collapse" id="menu-section-{{group?.group_id}}-{{class?.class_id}}" data-parent="#menu-section-{{group?.group_id}}">
                        <ul class="menu-sections__item-list list-unstyled">
                          @for (location of locations; track location) {
                            <li [ngClass]="class?.class_id === selectedClass?.class_id && location?.location_id === selectedLocation?.location_id ? 'is-active': null" (click)="setLocation(location,class)">
                              <a href="javascript:;">
                                {{location?.location_name}}
                              </a>
                            </li>
                          }
                        </ul>
                      </div>
                    </div>
                  }
                </div>
              }


              <div class="menu-sections__section">
                <div class="menu-sections__title">
                  <small>Policy Cover</small>
                </div>

                @for (location of nonlocation; track location) {
                  <div class="menu-sections__item">
                    <a href="javascript:;" (click)="setLocation(location)" class="menu-sections__item-title">
                      <div class="menu-sections__item-text">
                        <img src="assets/icn/class/sm-benefit.svg" class="icon icon--lg">
                        <h4>{{location?.answer}}</h4>
                      </div>
                    </a>
                  </div>
                }
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="layout__main">
      <div class="card card--edit card--edit-summary">
        <div class="card-body">
          <div class="card__notify" id="pause-notify" style="display: none">
            <div class="notice notice--transparent">
              <div class="notice__content">
                <svg class="icon">
                  <use xlink:href="#warning"></use>
                </svg>
                <p>Cover on this item will be paused from <strong>[date]</strong> –
                <strong>[date]</strong>.
              </p>
            </div>
            <a href="#" class="button-control"><strong>Edit</strong></a>
          </div>
        </div>

        <div class="card__notify" id="cancel-notify" style="display: none">
          <div class="notice notice--transparent">
            <div class="notice__content">
              <svg class="icon">
                <use xlink:href="#warning"></use>
              </svg>
              <p>Cover on this item will be cancelled on <strong>[date]</strong>.</p>
            </div>
            <a href="#" class="button-control"><strong>Edit</strong></a>
          </div>
        </div>

        <div class="card__notify card__notify--info" id="added-notify" style="display: none">
          <div class="notice notice--info notice--transparent">
            <div class="notice__content">
              <svg class="icon">
                <use xlink:href="#info"></use>
              </svg>
              <p>Cover on this item will be cancelled on <strong>[date]</strong>.</p>
            </div>
            <a href="#" class="button-control"><strong>Edit</strong></a>
          </div>
        </div>

        <div class="card__notify" id="tpq-notify" style="display: none">
          <div class="notice notice--transparent">
            <div class="notice__content">
              <svg class="icon">
                <use xlink:href="#warning"></use>
              </svg>
              <p>The previous changes you made to this item conflicted with <strong>[Cost
              Conscious]</strong>. Please update and save your answers to see if the
            product would become viable.</p>
          </div>
        </div>
      </div>

      <div class="card__content card__content--item">
        <small>Locations</small>
        <h4>{{selectedLocation?.location_name}}</h4>

        <div class="card__actions">
          <a href="#cancel-alert-modal" data-toggle="modal" class="button-control button-control--sm button-control--tight">
            <svg class="icon">
              <use xlink:href="#trash-bin"></use>
            </svg>
            <small>Remove Location</small>
          </a>
        </div>
      </div>
    </div>
  </div>

  @if (questions?.length > 0) {
    <div class="card card--edit">
      <div class="card-body">
        <div class="card__content">
          @for (question of questions; track question; let last = $last) {
            @if (question?.hidden === 0) {
              <app-question-controller
                [question]="question"
                [showLabel]="true"
                [controlCssClass]="(!last ? ' mb-30' : '')"
                [readOnly]="readonly"
                [isEditModal]="true"
                [showParent]="false"
                [childItemQuestions]="getItemChildrenQuestions(question)"
                (questionAnswer)="questionResponse($event)">
              </app-question-controller>
            }
          }
        </div>
      </div>
    </div>
  }


</div>
</div>
</div>
</main>
